const COMPANIES_HOUSE_SEARCH_URL =
  'https://find-and-update.company-information.service.gov.uk/search/officers'

export const buildCompaniesHouseSearchUrl = (applicantName: string) => {
  return `${COMPANIES_HOUSE_SEARCH_URL}?q=${encodeURIComponent(applicantName)}`
}
